import React from "react";
import { COPY } from "@/data/waitlistOptions";
import { LANDING } from "@/constants/testIds/waitlist";

export const SiteFooter = () => (
  <footer
    data-testid={LANDING.siteFooter}
    className="border-t border-white/10"
  >
    <div className="mx-auto max-w-5xl px-6 sm:px-8 py-10">
      <p className="font-condensed uppercase tracking-[0.32em] text-white/55 text-xs sm:text-sm text-center">
        {COPY.footer}
      </p>
    </div>
  </footer>
);
